var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Features")]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "custom-control custom-switch" }, [
        _c("input", {
          staticClass: "custom-control-input",
          attrs: { type: "checkbox", id: "customSwitch1" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "custom-control-label",
            attrs: { for: "customSwitch1" },
          },
          [_vm._v("Optimization"), _c("sup", [_vm._v("BETA")])]
        ),
        _vm._v(" "),
        _c(
          "small",
          { staticClass: "form-text text-muted", attrs: { id: "emailHelp" } },
          [
            _vm._v(
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lobortis scelerisque nisl id venenatis. Aliquam erat volutpat. Cras odio mi, venenatis id mi at, mattis rutrum dui. Integer ut lectus ante. Mauris congue mi ut quam iaculis consectetur. Proin auctor lorem sapien, id rutrum elit suscipit a."
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "custom-control custom-switch" }, [
        _c("input", {
          staticClass: "custom-control-input",
          attrs: { type: "checkbox", disabled: "", id: "customSwitch2" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "custom-control-label",
            attrs: { for: "customSwitch2" },
          },
          [_vm._v("Jira integration"), _c("sup", [_vm._v("BETA")])]
        ),
        _vm._v(" "),
        _c(
          "small",
          { staticClass: "form-text text-muted", attrs: { id: "emailHelp" } },
          [
            _vm._v(
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lobortis scelerisque nisl id venenatis. Aliquam erat volutpat. Cras odio mi, venenatis id mi at, mattis rutrum dui. Integer ut lectus ante. Mauris congue mi ut quam iaculis consectetur. Proin auctor lorem sapien, id rutrum elit suscipit a."
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("br"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }